<template>
  <div class="animated fadeIn col-md-12">
    <searchCard
      :filterCatch="true"
      :title="$lang.profileLang.term_list"
      :url="url"
      :html="false"
      ref="searchTerm"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="goToAddTerm"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 mb-3 border-bottom d-md-flex d-block align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle d-flex align-items-center justify-content-center"
            >
              <i class="fas fa-graduation-cap text-primary" />
            </span>
            <b
              class="px-1 fs_1rem"
              v-text="`${pathOr('', ['caption'], item)}`"
            />
          </div>
          <small
            class="text-muted d-md-block d-flex align-items-center justify-content-between"
          >
            <div
              v-b-tooltip
              title="ثبت کننده"
              v-if="pathOr(null, ['created_by'], item)"
            >
              <i class="fas fa-user mr-1" />
              <span v-text="pathOr('', ['created_by'], item)" />
            </div>
            <div v-b-tooltip title="زمان ایجاد">
              <i class="fas fa-clock mr-1" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </div>
          </small>
        </b-col>
        <b-col>
          <b-row align-v="center" class="mx-0">
            <b-col cols="12" md="4" class="py-2">
              <b v-text="'شماره دوره'" />:
              <span class="text-muted" v-text="pathOr('', ['id'], item)" />
            </b-col>
            <b-col cols="12" md="8" class="py-2">
              <b v-text="$lang.company" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['company', 'caption'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="py-2"
              v-if="pathOr(null, ['license', 'caption'], item)"
            >
              <b v-text="'نوع مجوز'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['license', 'caption'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md="4"
              class="py-2"
              v-if="pathOr(null, ['cooperation', 'caption'], item)"
            >
              <b v-text="'نوع همکاری'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['cooperation', 'caption'], item)"
              />
            </b-col>
            <b-col cols="12" md="8" class="py-2">
              <b v-text="'نمایش لینک ثبت نام'" />:
              <span
                class="text-muted"
                v-text="pathOr(false, ['link_show'], item) ? 'بله' : 'خیر'"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <b v-text="'زمان شروع'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['start_date', 'jalali'], item)"
              />
            </b-col>
            <b-col cols="12" md="8" class="py-2">
              <b v-text="'زمان پایان'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['end_date', 'jalali'], item)"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <b v-text="'وضعیت'" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['status', 'caption'], item)"
              />
            </b-col>
            <b-col cols="12" md="8" class="py-2">
              <b v-text="'تعداد وضعیت‌ها'" />:
              <span
                class="text-muted"
                v-text="pathOr(0, ['term_state_count'], item)"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <b v-text="'تعداد پرونده فعال'" />:
              <span
                class="text-muted"
                v-text="pathOr(0, ['active_parvandeh_count'], item)"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <b v-text="'تعداد پرونده مختومه'" />:
              <span
                class="text-muted"
                v-text="pathOr(0, ['end_parvandeh_count'], item)"
              />
            </b-col>
            <b-col cols="12" md="4" class="py-2">
              <b v-text="'تعداد پیش ثبت نام موفق'" />:
              <span
                class="text-muted"
                v-text="pathOr(0, ['pre_register_count'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="12" class="py-1 mt-3 border-top">
          <b-row align-v="center" align-h="between" class="w-100 m-0">
            <b-col cols="12" md="auto" class="px-0" />
            <b-col cols="12" md="" class="text-right px-0">
              <b-button
                v-if="isAdmin(permissions)"
                class="m-1"
                size="sm"
                variant="outline-danger"
                @click="showConfirmModal(item)"
              >
                <i class="fas fa-trash mr-1" />
                {{ $lang.remove }}
              </b-button>
              <b-button
                v-if="isAdmin(permissions)"
                variant="outline-success"
                size="sm"
                @click="goToEditTerm(item)"
              >
                <i class="fas fa-edit mr-1" />
                <b v-text="$lang.edit" />
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </searchCard>
    <confirm
      v-model="confirmModal"
      :title="`حذف دوره`"
      :description="confirmDescription"
      dynamicClass=""
      :loading="loading"
      :preventDefault="true"
      @cancel="confirmModal = false"
      @ok="removeTerm"
    />
  </div>
</template>

<script>
import searchCard from "@/components/base/searchCard";
import confirm from "@/components/base/confirm";
import { pathOr, includes } from "ramda";
import { generateStoreGetters, isAdmin } from "@/shared/utils";

export default {
  components: {
    searchCard,
    confirm,
  },
  data() {
    return {
      url: this.$config.api_url + this.$config.profile.term,
      loading: false,
      addModal: false,
      permissions: [],
      modalMode: "add",
      currentItem: null,
      confirmModal: false,
    };
  },
  computed: {
    confirmDescription() {
      return `دقت کنید که دوره و کلیه وابستگی‌های آن حذف خواهند شد.
      <br><br><b>${this.$lang.are_you_sure}</b>`;
    },
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    getData() {
      this.$refs.searchTerm.getItems();
    },
    goToAddTerm() {
      this.$router.push({ name: "add_term" });
    },
    goToEditTerm(item) {
      const { code } = item;
      this.$router.push({ name: "edit_term", params: { code } });
    },
    showConfirmModal(item) {
      this.currentItem = item;
      this.confirmModal = true;
    },
    async removeTerm() {
      const { code } = this.currentItem;
      try {
        this.loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.term}/${code}`;
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.confirmModal = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
  },
};
</script>

<style scoped lang="scss">
.grid-img-crd {
  /* width: 150px;
  height: auto;
  margin: auto;
  display: block; */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  img {
    width: 95px;
    height: auto;
  }
}
.fs_1_3rem {
  font-size: 20px;
}
.w_h_35 {
  width: 35px;
  height: 35px;
}
.border_right {
  &_primary {
    border-right: 5px solid #17a2b8 !important;
  }
  &_info {
    border-right: 5px solid #63c2de !important;
  }
  &_success {
    border-right: 5px solid #4dbd74 !important;
  }
  &_danger {
    border-right: 5px solid #f86c6b !important;
  }
  &_warning {
    border-right: 5px solid #ffc107 !important;
  }
  &_secondary {
    border-right: 5px solid #c8ced3 !important;
  }
}

.card_block {
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  .time_block {
    transition: all 0.4s;
    -webkit-transition: all 0.4s;
    padding: 0 15px;
    border-radius: 0.25rem 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
  &:hover {
    transition: all 0.4s;
    -webkit-transition: all 0.4s;
    border-right-width: 10px !important;
    .time_block {
      transition: all 0.4s;
      -webkit-transition: all 0.4s;
      opacity: 1;
      box-shadow: 0px 7px 7px 0px #2f353a6e;
    }
  }
}
</style>
